export type ThemeName = 'atelier' | 'atelier-dark'

export const DEFAULT_THEME: ThemeName = 'atelier'

export const THEME_STORAGE_KEY = 'b101-theme'

export const THEME_LABELS: Record<ThemeName, string> = {
  atelier: 'Atelier',
  'atelier-dark': 'Atelier Dark',
}

export interface ThemePalette {
  '--color-ink': string
  '--color-ink-raised': string
  '--color-cream': string
  '--color-mute': string
  '--color-haze': string
  '--color-ember': string
  '--color-leaf': string
  '--color-sky': string
  '--color-selection-bg': string
  '--color-selection-text': string
  '--gradient-bloom-1': string
  '--gradient-bloom-2': string
  '--shadow-form': string
  '--shadow-button': string
  '--shadow-elevated': string
}

export const palettes: Record<ThemeName, ThemePalette> = {
  atelier: {
    '--color-ink': '#F5F0EB',
    '--color-ink-raised': '#EDE8E2',
    '--color-cream': '#2A2420',
    '--color-mute': '#8B7E74',
    '--color-haze': '#D4CBC2',
    '--color-ember': '#C4705A',
    '--color-leaf': '#5A7A5A',
    '--color-sky': '#6B8E7B',
    '--color-selection-bg': '#E8D5D0',
    '--color-selection-text': '#2A2420',
    '--gradient-bloom-1': '#E8D5D0',
    '--gradient-bloom-2': '#D4CBC2',
    '--shadow-form': '0 1px 3px rgba(42, 36, 32, 0.04), 0 12px 48px -12px rgba(196, 112, 90, 0.18)',
    '--shadow-button': '0 4px 16px -4px rgba(196, 112, 90, 0.40)',
    '--shadow-elevated': '0 2px 8px rgba(42, 36, 32, 0.06), 0 16px 48px -12px rgba(42, 36, 32, 0.12)',
  },
  'atelier-dark': {
    '--color-ink': '#1E1A16',
    '--color-ink-raised': '#2A2420',
    '--color-cream': '#E8E0D8',
    '--color-mute': '#9A8E82',
    '--color-haze': '#3D3832',
    '--color-ember': '#D4856A',
    '--color-leaf': '#7A9A7A',
    '--color-sky': '#8AA89A',
    '--color-selection-bg': '#3D3832',
    '--color-selection-text': '#E8E0D8',
    '--gradient-bloom-1': '#3D3832',
    '--gradient-bloom-2': '#2A2420',
    '--shadow-form': '0 1px 3px rgba(0, 0, 0, 0.20), 0 12px 48px -12px rgba(212, 133, 106, 0.15)',
    '--shadow-button': '0 4px 16px -4px rgba(212, 133, 106, 0.35)',
    '--shadow-elevated': '0 2px 8px rgba(0, 0, 0, 0.25), 0 16px 48px -12px rgba(0, 0, 0, 0.35)',
  },
}

export function isValidTheme(value: string | null): value is ThemeName {
  return value === 'atelier' || value === 'atelier-dark'
}
